import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_HANDOVERLISTENGINEERING,
  DELETE_HANDOVERLISTENGINEERING,
  UPDATE_HANDOVERLISTENGINEERING,
  ADD_NEW_HANDOVERLISTENGINEERING,
} from "./actionType";

import {
  getHandoverListEngineeringSuccess,
  getHandoverListEngineeringFail,
  deleteHandoverListEngineeringSuccess,
  deleteHandoverListEngineeringFail,
  updateHandoverListEngineeringSuccess,
  updateHandoverListEngineeringFail,
  addHandoverListEngineeringSuccess,
  addHandoverListEngineeringFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getHandoverListEngineeringApi,
  updateHandoverListEngineeringApi,
  deleteHandoverListEngineeringApi,
  addNewHandoverListEngineeringApi
} from "../../helpers/backend_helper";

function* getHandoverListEngineering({ payload: handoverListEngineering }) {
  try {
    const response = yield call(getHandoverListEngineeringApi, handoverListEngineering);
    yield put(getHandoverListEngineeringSuccess(GET_HANDOVERLISTENGINEERING, response.data));
  } catch (error) {
    yield put(getHandoverListEngineeringFail(GET_HANDOVERLISTENGINEERING, error));
  }
}

function* onUpdateHandoverListEngineering({ payload: handoverListEngineering }) {
  try {
    const response = yield call(updateHandoverListEngineeringApi, handoverListEngineering);
    yield put(updateHandoverListEngineeringSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateHandoverListEngineeringFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteHandoverListEngineering({ payload: handoverListEngineering }) {
  try {
    const response = yield call(deleteHandoverListEngineeringApi, handoverListEngineering);
    yield put(deleteHandoverListEngineeringSuccess({ handoverListEngineering, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteHandoverListEngineeringFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewHandoverListEngineering({ payload: handoverListEngineering }) {
  try {
    const response = yield call(addNewHandoverListEngineeringApi, handoverListEngineering);
    yield put(addHandoverListEngineeringSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addHandoverListEngineeringFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetHandoverListEngineering() {
  yield takeEvery(GET_HANDOVERLISTENGINEERING, getHandoverListEngineering);
}

export function* watchUpdateHandoverListEngineering() {
  yield takeEvery(UPDATE_HANDOVERLISTENGINEERING, onUpdateHandoverListEngineering);
}

export function* watchDeleteHandoverListEngineering() {
  yield takeEvery(DELETE_HANDOVERLISTENGINEERING, onDeleteHandoverListEngineering);
}

export function* watchAddNewHandoverListEngineering() {
  yield takeEvery(ADD_NEW_HANDOVERLISTENGINEERING, onAddNewHandoverListEngineering);
}

function* handoverListEngineeringSaga() {
  yield all([
    fork(watchGetHandoverListEngineering),
    fork(watchDeleteHandoverListEngineering),
    fork(watchUpdateHandoverListEngineering),
    fork(watchAddNewHandoverListEngineering)
  ]);
}

export default handoverListEngineeringSaga;
